// React and Redux imports
import { useDispatch, useSelector } from 'react-redux';

// Chakra UI components
import {
  Box,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';

// Actions and constants
import { deleteSubQuestProgressionAction } from 'store/modules/subQuestReport/subQuest-report-action';
import { subQuestReportActions } from 'store/modules/subQuestReport/subQuest-report-slice';
import { ReducerStatus } from 'utils/constants';

// Common components
import ResultModal from 'components/common/modals/ResultModal';

function DeleteProgressionMd() {
  const dispatch = useDispatch();

  // Select delete progression state from Redux store
  const deleteProgression = useSelector(
    (state) => state.subQuestReport.deleteProgression
  );

  // Toggle the delete progression modal
  const handleToggleDeleteModal = (isOpen) => {
    dispatch(subQuestReportActions.toggleDeleteProgressionModal(isOpen));
  };

  // Dispatch action to delete sub-quest progression
  const handleDeleteSubQuestProgression = () => {
    dispatch(
      deleteSubQuestProgressionAction({
        subQuestId: deleteProgression.subQuestId,
        progressionId: deleteProgression.progressionId,
      })
    );
  };

  // Reset the delete progression status
  const handleResultButton = () => {
    dispatch(subQuestReportActions.resetDeleteProgressionStatus());
  };

  return (
    <Box>
      {/* Show ResultModal if the delete operation succeeded or failed */}
      {deleteProgression.status === ReducerStatus.SUCCEEDED ||
      deleteProgression.status === ReducerStatus.FAILED ? (
        <ResultModal
          isOpen={deleteProgression.modal}
          onSubmit={handleResultButton}
          isError={deleteProgression.status === ReducerStatus.FAILED}
          title={
            deleteProgression.status === ReducerStatus.SUCCEEDED
              ? 'Deleted'
              : 'Server Error'
          }
          message={
            deleteProgression.status === ReducerStatus.SUCCEEDED
              ? 'The selected progression has been deleted successfully. If you believe this was done in error, please contact the administrator.'
              : deleteProgression.error?.data?.title || 'Server Error'
          }
        />
      ) : (
        // Show confirmation modal for delete operation
        <Modal
          isOpen={deleteProgression.modal}
          onClose={() => handleToggleDeleteModal(false)}
          isCentered
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Confirmation Required</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              Are you certain you want to delete this progression? Please note
              that all related progression&apos;s sessions will also be deleted.
            </ModalBody>

            <ModalFooter>
              {/* Close button */}
              <Button
                colorScheme="gray"
                mr={3}
                onClick={() => handleToggleDeleteModal(false)}
              >
                Close
              </Button>
              {/* Proceed button */}
              <Button
                colorScheme="red"
                isLoading={deleteProgression.status === ReducerStatus.LOADING}
                onClick={() => handleDeleteSubQuestProgression()}
              >
                Proceed
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </Box>
  );
}

export default DeleteProgressionMd;
